<template>
    <div class="home">
        <h1>Homepage</h1>
        <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Placeat qui quibusdam
            laboriosam ipsum vitae, consequatur labore illum quod doloremque? Fugit exercitationem
            qui aspernatur itaque nulla eos accusamus nam cumque consectetur quisquam ipsam, iste
            corporis voluptatum, eligendi quam. Quis inventore facilis error tempora facere nisi
            dolor maiores dolores sit cum, quo nulla officia ut veniam vel rem. Provident maiores,
            soluta sapiente ad labore minus nemo alias nesciunt veritatis recusandae repudiandae
            doloremque deleniti cumque fugiat molestiae quisquam.
        </p>
        <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusantium natus laudantium
            saepe id non voluptate voluptas. Dolorem earum amet incidunt dolorum, quo consequatur
            non quaerat esse, exercitationem velit illum ducimus maxime atque explicabo quis!
            Aspernatur quo obcaecati officia maiores rem. Alias cupiditate, magnam quam, harum
            libero autem, voluptas eius eveniet magni odio temporibus. Veritatis assumenda eaque
            ipsam vitae commodi molestias vel distinctio cumque corrupti natus exercitationem
            perferendis cupiditate officiis a tempora labore enim voluptatem libero, dolorem ullam.
            In eaque numquam provident harum qui commodi reiciendis recusandae dolore? Aut labore
            nemo soluta libero? Harum corporis quas assumenda soluta ipsum. Praesentium tenetur unde
            sunt iure dolor, illum officiis cum eligendi, accusantium, temporibus in non maxime
            suscipit rem.
        </p>
    </div>
</template>

<script>
export default {
    name: 'Home',
    components: {},
};
</script>
